import { styled } from "@mui/material";

interface DocumentBadgeProps {
  color?: string;
  backgroundColor?: string;
}

export const DocumentBadge = styled("span")(({ backgroundColor, color }: DocumentBadgeProps) => ({
  backgroundColor,
  color,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  padding: "4px 8px",
  alignItems: "center",
  mixBlendMode: "multiply",
  borderRadius: "4px",
}));
